import React from "react";
import { Formik, Form, Field } from "formik";
import { Button, LinearProgress } from "@material-ui/core";
import { TextField } from "formik-material-ui";
import { makeStyles } from "@material-ui/core";
import yellow from "@material-ui/core/colors/yellow";
import capchainAbi from "../../ethereum/abi/capchainFactory";
import { ethers } from "ethers";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  formField: {
    marginBottom: "5px",
    fontFamily: "Work Sans, sans-serif",
  },
  buttonstyle: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: "bold",
    fontSize: "16px",
    color: yellow[800],
    background: "#fff",
    "&:hover": {
      backgroundColor: yellow[400],
      color: "#000",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
}));

const CapchainInput = ({ onSelect }) => {
  const { formField, buttonstyle } = useStyles();
  const wallet = useSelector((state) => state.wallet);

  const handleChange = (hash) => {
    onSelect(hash);
  };

  const interactContract = async (values) => {
    const capChainAddress = "0xac08b9bc67C4F4C54bB83A73062a2C7315072140";
    const capchainContract = new ethers.Contract(
      capChainAddress,
      capchainAbi,
      wallet.signer
    );
    const WithSigner = capchainContract.connect(wallet.signer);
    const tx = await WithSigner.createContract(
      values.TokenName,
      values.TokenSymbol,
      wallet.account,
      wallet.account,
      ethers.BigNumber.from(values.TokenSupply)
    );

    console.log("tx", tx);
    let lastConfirms = -1;
    async function handler(blockNumber) {
      let receipt = await wallet.provider.getTransactionReceipt(tx.hash);
      if (receipt == null || receipt.confirmation < lastConfirms) {
        // A re-org; do what you need here
        console.log("blockNumber-->", blockNumber);
      }
    }
    wallet.provider.on("block", handler);

    tx.wait(1).then((receipt) => {
      // This gets called once there are 3 confirmations
      console.log("tx confirmed");
      console.log("reciept", receipt);
      handleChange(receipt.transactionHash);
      wallet.provider.removeListener("block", handler);
    });
  };
  return (
    <>
      <Formik
        initialValues={{
          TokenName: "",
          TokenSupply: "",
          TokenSymbol: "",
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          interactContract(values);
          resetForm();
        }}
      >
        {({ submitForm, isSubmitting }) => (
          <Form>
            <Field
              className={formField}
              component={TextField}
              name="TokenName"
              label="TokenName"
              fullWidth
              variant="outlined"
            />
            <br />
            <br />
            <Field
              component={TextField}
              label="TokenSymbol"
              name="TokenSymbol"
              fullWidth
              variant="outlined"
              className={formField}
            />
            <br />
            <br />
            <Field
              component={TextField}
              label="TokenSupply"
              name="TokenSupply"
              fullWidth
              variant="outlined"
              className={formField}
            />
            {isSubmitting && <LinearProgress />}
            <br />
            <br />
            <Button
              variant="contained"
              disabled={isSubmitting}
              onClick={submitForm}
              fullWidth
              className={buttonstyle}
            >
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CapchainInput;
